// extracted by mini-css-extract-plugin
module.exports = {"container":"job-module--container--2zhjJ","job":"job-module--job--30Xgc","company":"job-module--company--31XaM","stint":"job-module--stint--2PC8y"};